import React from 'react';
import { useTranslation } from 'react-i18next';

const pointsFallback = [
  'Compliance with environmental and quality policies',
  'Functional, low-impact paint development',
  'Waste reduction through eco-friendly materials',
  '100% recycled and recyclable packaging',
  '3R approach: Reduce, Reuse, Recycle',
  'Minimized carbon footprint in all operations',
  'Promotion of circular economy practices',
];

const Sustainability = () => {
  const { t } = useTranslation();
  const points =
    t('home.sustainability.points', { returnObjects: true }) || pointsFallback;
  return (
    <section className="bg-[#EDEDED] w-full">
      <div className="px-4 sm:px-6 xl:px-8 py-10 md:py-20">
        <div className="max-w-[1250px] mx-auto flex items-start md:flex-row flex-col justify-between gap-10">
          <div className="md:sticky top-20 max-w-[722px] w-full">
            <img
              src="/assets/sustainability.webp"
              alt="Sustainability"
              width={722}
              height={675}
            />
          </div>
          <ul className="text-[#111827] max-w-[468px] w-full space-y-8 lg:space-y-[60px] ml-2 sm:ml-4 list-disc libre-baskerville pl-3 sm:pl-5">
            {points.map((p, i) => (
              <li
                key={i}
                className="text-[22px] lg:text-[28px] text-wrap whitespace-pre-wrap leading-[27px] lg:leading-[54px] font-normal text-[#1D1D1F]"
              >
                {p}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Sustainability;
